import { TextField, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import { useState } from "react";
import firebaseConfig from "../firebase";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';
function RichTextCreate() {
  const db = getFirestore(firebaseConfig)
  const navigate = useNavigate()
  const [contentText, setContentText] = useState('');
  const [contentType, setContentType] = useState('');
  const contentCollectionRef = collection(db, "Content");

  const createContent = async () => {
    await addDoc(
      contentCollectionRef,
      {
        contentText: contentText,
        contentType: contentType,
      }
    );
    alert('บันทึกเรียบร้อย')
    navigate('/content');
    
  };
  return (
    <Container class={Paper}>
      <Stack spacing={3}>
      <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          เพิ่มคู่มือ
        </Typography>
        <TextField  inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="หัวข้อ*" onChange={(event) => {
          setContentType(event.target.value);
        }} />
        <ReactQuill value={contentText}
          onChange={setContentText}
          theme={'snow'}
          modules={{
            toolbar: [
              [{ 'header': [1, 2, false] }, { 'font': [] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' },
              { 'indent': '-1' }, { 'indent': '+1' }],
              ['link', 'image', 'video'],
              ['clean']
            ]
          }} />
          <Stack direction="row" justifyContent="flex-end" spacing={3}>
          <Button  sx={{ fontFamily:'Prompt'}}   onClick={() => navigate('/content')} variant="text" color="error">ยกเลิก</Button>
        <Button onClick={createContent} sx={{ fontFamily:'Prompt'}} variant="outlined" color="success">บันทึก</Button>
        </Stack>
      </Stack>
    </Container>
  )

}


export default RichTextCreate;
